// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { KeepAliveContext, 
} from './context';

const KeepAliveLayout = (props)=>{
  const keepElements = React.useRef<any>({});
  const [cacheKeyMap, setCacheKeyMap] = React.useState({});
  const [keepalive, setKeepalive] = React.useState([/./]);

  function dropByCacheKey(path: string) {
    if(keepElements.current[path.toLowerCase()]){
      delete keepElements.current[path.toLowerCase()];
      setCacheKeyMap(cacheKeyMap => ({
        ...cacheKeyMap,
        [path.toLowerCase()]: Math.random()
      }))
    }
  }
  return (
    <KeepAliveContext.Provider
      value={ {
        keepalive,
        setKeepalive,
        keepElements,
        cacheKeyMap,
        dropByCacheKey,
      }}
      {...props}
    />
  )
}
export function rootContainer(container) {
  return React.createElement(KeepAliveLayout, null, container);
}
